<template>
    <div class="content-block dx-card responsive-paddings">
        <div class="container">
            <div class="information">
                <fieldset class="product">
                    <legend>{{ $t('product.software') }}</legend>

                    <div class="product-info">
                        <img class="logo" src="../../assets/printstat-rgb.png" alt="PrintStat">

                        <div class="data-field">
                            <div class="label">{{ $t('product.softwareVersion') }}</div>
                            <div class="value">{{ `${appVersion}.${appInfo.feBuildNum} build ${versionNumber}` }}</div>
                        </div>
                        <div class="data-field">
                            <div class="label">{{ $t('product.releaseDate') }}</div>
                            <div class="value">{{ releaseDate }}</div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="product">
                    <legend>{{$t('product.copyright')}}</legend>

                    <div class="product-info">
                        <img class="logo" src="../../assets/Nicotech.png" alt="Nicotech">

                        <div class="copyright">&#169; 2015-{{ currentYear }} ООО &#171;Никотех&#187;</div>
                        <div class="resource">
                            <a class="link" href="https://nicotech.ru/" target="_blank">https://nicotech.ru</a>
                            <a class="link" href="https://printstat.ru/" target="_blank">https://printstat.ru</a>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div class="container-support">
                <fieldset>
                    <legend>{{ $t('product.technicalSupport') }}</legend>

                    <div class="data-field">
                        <div class="label">{{ $t('product.email') }}</div>
                        <div>
                            <a href="mailto:support@nicotech.ru">support@nicotech.ru</a>
                        </div>
                    </div>
                    <div class="data-field">
                        <div class="label">{{ $t('product.tel') }}</div>
                        <div>
                            <a href="tel:+74995003829">+7 (499) 500-3829</a>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div v-if="isCloudMode && aclUser.hasRole('ADMIN')">
                <fieldset class="product">
                    <legend>{{ $t('product.downloads') }}</legend>

                    <div v-for="file in disk" :key="file.id">
                        <a :href="file.file" target="_blank" rel="noopener noreferrer">{{ file.name }}</a>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>
import baseView from "../base.vue";
import appInfo from "../../app-info";

import { getBuildVersion } from "@/services/api";
import { AclHandler } from "@/services/acl-handler";

import { DataBacked } from "@/mixins/dataBackedMixin";

import axios from "axios";
import moment from "moment";

export default {
    name: 'Product',
    mixins: [ DataBacked ],
    extends: baseView,
    components: {
    },
    data () {
        return {
            appInfo,
            isCloudMode: this.$store.getters.isCloudMode,
            disk: [],
            appVersion: '',
            versionNumber: '',
            releaseDate: '',
            isUploadFile: false,
            version: null,
            currentYear: moment().year(),
        }
    },
    computed: {
        appUser() {
            return this.$store.getters.user;
        },
        aclUser() {
            return new AclHandler(this.appUser, this.isCloudMode);
        },
    },
    methods: {
        async loadData() {
            try {
                if (this.isCloudMode && this.aclUser.hasRole('ADMIN')) {
                    await axios({
                        method: 'get',
                        url: 'https://cloud-api.yandex.net/v1/disk/public/resources?public_key=https://disk.yandex.ru/d/Hp9iKnYbYpMSnA?ncrnd=69853'
                    })
                    .then(response => {
                        const files = response.data._embedded.items.filter(el => el.type === 'file');
                        this.disk = files.slice(0, 50);
                    })
                }

                this.version = await getBuildVersion();
                this.releaseDate = this.version.releaseDate ? this.version.releaseDate : '';
                this.appVersion = this.version.appVersion ? this.version.appVersion.replace(/[^\d.-]/g, '') : '';
                this.versionNumber = this.version.buildNumber ? this.version.buildNumber : '';
            } catch (error) {
                this.onDataError(error);
            }
        }
    },
    async created() {
        document.title = `${appInfo.title} - ${this.$t('product.title')}`;
        this.$store.commit("setBreadcrumb", [{
            link: "/product",
            title: this.$t('product.title')
        }]);

        this.loadData();
    }
}
</script>

<style lang="scss" scoped>
a {
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

fieldset {
    margin: 0;
    border-radius: 4px;
    border: 1px solid #ddd;

    legend {
        font-weight: 500;
    }
}

.container {
    max-width: 650px;
}

.information {
    display: flex;
    flex-direction: row;
    column-gap: 24px;
    margin-bottom: 10px;

    .product {
        flex: 1;

        .product-info {
            display: flex;
            flex-direction: column;
            padding: 0 14px;

            .logo {
                align-self: flex-start;
                margin-bottom: 10px;
                height: 50px;
            }

            .copyright {
                color: #666;
            }
        }
    }

    .resource {
        .link:first-child {
            margin-right: 24px;
        }
    }
}

.data-field {
    display: flex;
    flex-direction: row;

    .label {
        color: #666;
        margin-right: 8px;
    }

    .value {
        font-weight: 500;
    }
}
</style>